const getApiUrl = () => {
  if (process.env.NODE_ENV === 'development') return 'http://localhost:4000/api'
  if (window.location.hostname.split('.')[0] === 'demo') return 'https://demo_api.streetise.com/api'
  return 'https://api.streetise.com/api' 
}

export const apiUrl = getApiUrl()
